export default __webpack_public_path__ + "static/media/bubble_nova_xl2.bcb3fb40.png";